import React, { useEffect, useRef, useState } from "react";
import styles from "./Stores.module.css";
import { SearchInput } from "../../components";
import storeImg from "../../assets/storeImg.png";
import { IoIosArrowForward } from "react-icons/io";
import { List } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import StoreMiddleware from "../../store/Middlewares/StoreMiddleware";
import { IMG_URL } from "../../store/Apis";
import dummyImg from '../../assets/dummy.png';

const Stores = () => {
  const navigate = useNavigate();
  const storeOption = new Array(2).fill({
    image: storeImg,
    name: "The More Store",
  });
  const { state } = useLocation()
  const previousData = state;
  console.log('previousData',previousData)
  useEffect(() => {
    getStoreList();
    getLanguage();
  }, []);

  const getLanguage = async () => {
    try {
      const language = localStorage.getItem('@selectedLanguage');
      i18n.changeLanguage(language);
    } catch (e) {
      console.log(e);
    }
  };

  const StoreList = useSelector(state => state.StoreReducer.StoreList);
  const [search, setSearch] = useState('');
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const timeout = useRef(null);

  const getStoreList = () => {
    let data = {
      search: search,
    };

    dispatch(StoreMiddleware.getStore(data));
  };

  const onSearchSubCategories = text => {
    let data = {
      search: text,
    };
    setSearch(text);
    clearTimeout(timeout.current);
    timeout.current = setTimeout(() => {
      dispatch(StoreMiddleware.getStore(data));
    }, 1000);
  };

  const renderStore = (item) => {
    return (
      <div className={styles.listItem} onClick={() => navigate("/WorkOrderRequestForm/Stores/Inventory", {
        state: {
          data: item,
          getData: previousData?.getData,
          screenName: previousData?.screenName,
        }
      })}>
        <div className={styles.listLeft}>
          <img src={item?.image ? IMG_URL + item?.image : dummyImg} />
          <h1>{item?.name}</h1>
        </div>
        <div className={styles.listLeft}>
          <IoIosArrowForward color="var(--white-color)" size={25} />
        </div>
      </div>
    );
  };
  return (
    <div className={styles.mainDiv}>
      <div className={styles.heading}>
        <h1>Stores</h1>
      </div>
      <div className={styles.subMain}>
        <div className={styles.searchInput}>
          <SearchInput
            placeholder={"Search"}
            onChange={(e) => onSearchSubCategories(e.target.value)}
          />
        </div>
        <List
          //   className={styles.inventoryList}
          style={{ width: "100%" }}
          //   grid={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2, xxl: 2 }}
          dataSource={StoreList}
          //   footer={loadMore}
          renderItem={renderStore}
        />
      </div>
    </div>
  );
};

export default Stores;
